// extracted by mini-css-extract-plugin
export default {"mapContainer":"styles_mapContainer__D3BnG","errorBlock":"styles_errorBlock__wcOXg"};